/** Process uptime in ms, or null where the Node API is absent, as in the Edge runtime. */
function uptimeMs(): number | null {
  const nodeProcess = (globalThis as { process?: { uptime?: () => number } }).process;

  return typeof nodeProcess?.uptime === "function" ? Math.round(nodeProcess.uptime() * 1000) : null;
}

/** Logs a structured boot-timing marker with the stage name and process uptime in ms. Imports nothing. */
export function bootMark(stage: string, extra?: Record<string, unknown>): void {
  if (process.env.VH_BOOT_MARK_DISABLED === "1") return;

  try {
    console.error(
      JSON.stringify({
        severity: "INFO",
        message: "VH_BOOT_MARK",
        stage,
        uptimeMs: uptimeMs(),
        rev: process.env.K_REVISION ?? "",
        ...extra,
      })
    );
  } catch (error) {
    console.error("VH_BOOT_MARK serialization failed", error);
  }
}
